/* eslint-disable @typescript-eslint/naming-convention */
export enum EUserMutationType {
	SET_USER = 'setUser',
	SET_ACCESS_TOKEN = 'setAccessToken',
}
